import type { XaiModelType } from './provider.model-types'

export const MODEL_DEEPSEEK_V3: XaiModelType = {
  modelId: 'deepseek@deepseek-chat_v3',
  provider: 'deepseek',
  model: 'deepseek-chat',
  modelName: 'Deepseek V3',
}
export const MODEL_DEEPSEEK_R1: XaiModelType = {
  modelId: 'deepseek@deepseek-reasoner_r1',
  provider: 'deepseek',
  model: 'deepseek-reasoner',
  modelName: 'Deepseek R1',
}

export const MODEL_QIANFAN_ERNIE4: XaiModelType = {
  modelId: 'qianfan@ernie-4.0-8k',
  provider: 'qianfan',
  model: 'ernie-4.0-8k',
  modelName: '百度 ERNIE-4.0-8K',
  disabled: true,
}

export const MODEL_SILICONFLOW_DEEPSEEK_V3 = {
  modelId: 'siliconflow@deepseek#deepseek-chat_v3',
  provider: 'siliconflow',
  model: 'deepseek-ai/DeepSeek-V3',
  modelName: 'Deepseek V3',
}

export const MODEL_SILICONFLOW_DEEPSEEK_R1 = {
  modelId: 'siliconflow@deepseek#deepseek-reasoner_r1',
  provider: 'siliconflow',
  model: 'deepseek-ai/DeepSeek-R1',
  modelName: 'Deepseek R1',
}

export const xaiModels: XaiModelType[] = [
  MODEL_SILICONFLOW_DEEPSEEK_V3,
  MODEL_SILICONFLOW_DEEPSEEK_R1,
  // MODEL_DEEPSEEK_V3,
  // MODEL_DEEPSEEK_R1,
  MODEL_QIANFAN_ERNIE4,
]
